<script>
import entreprise from '../../../assets/icons/ic-entreprise.svg'
import ic_enterprise from "@/assets/icons/entreprise.svg";
import { updateRequestExpert, getAccountant } from "@/component/cdevs/allFunctions";
import ic_service from "@icon/ic_service.svg";
import { createAffectation } from "@/component/cdevs/allFunctions";

export default {
  name: 'AffectationPopup',
  data() {
    return {
      icons: { entreprise, ic_enterprise, ic_service },
      // Autocomplete / sélection
      search: '',
      timer: null,
      filteredSuggestions: [],
      showOptions: false,
      allComptables: [],
      selectedAccountant: null,
      isLoading: false,
      charge: false,
    };
  },
  emits: ['closeDetail'],
  props: {
    oneDetail: {
      type: Object,
      required: true,
    },
  },

  created() {
    console.log('this.oneDetail', this.oneDetail);
    // Charger la liste des comptables
    this.loadAllComptables();
    
    // Pré-remplir si un comptable est déjà choisi
    const client = this.oneDetail?.request?.clientChoice;
    if (client) {
      this.selectedAccountant = client;
      this.search = client.fullName || `${client.firstName || ''} ${client.lastName || ''}`.trim();
    }
  },

  watch: {
    // Afficher automatiquement tous les comptables quand ils sont chargés
    allComptables(newVal) {
      if (newVal && newVal.length > 0) {
        // Initialiser les suggestions avec tous les comptables
        this.filteredSuggestions = newVal;
      }
    },
  },

  methods: {
    closeDetail() {
      this.$emit('closeDetail');
    },

    cleanObject(obj) {
      return Object.fromEntries(
        Object.entries(obj).filter(
          ([_, value]) => value !== null && value !== undefined && value !== ""
        )
      );
    },
    
    // Chargement de tous les comptables
    async loadAllComptables() {
      this.isLoading = true;
      const data = {
        apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
        limit: 1000,
        page: 1,
        type: "CERTIFIED_ACCOUNTANT",
      };
      const cleanedData = this.cleanObject(data);
      
      try {
        const response = await getAccountant(cleanedData);
        console.log('getAccountant response ▶', response);
        
        // Gestion robuste de la réponse comme dans AllCharteredAccountant.vue
        // response peut contenir différentes formes, gérer les cas courants
        // priorité: response.data (liste), response.meta.total, response.total, response.count
        // on extrait la liste
        const list = response.data && Array.isArray(response.data) 
          ? response.data 
          : (response.data && response.data.items) || response.data || [];
        
        // Normaliser les données
        this.allComptables = (list || []).map((item) => ({
          ...item,
          fullName: item.fullName || `${item.firstName || ''} ${item.lastName || ''}`.trim(),
        }));
        
        // Initialiser les suggestions avec tous les comptables
        this.filteredSuggestions = this.allComptables;
        
        console.log(`${this.allComptables.length} comptables chargés`);
      } catch (error) {
        console.error('Erreur chargement comptables:', error);
        // Affiche les détails renvoyés par l'API si présents
        const apiMessage = error?.response?.data?.message || error?.response?.data || error.message;
        console.error('Détails API:', apiMessage);
        const toastMsg = Array.isArray(apiMessage) ? apiMessage.join(' / ') : (apiMessage && typeof apiMessage === 'object' ? JSON.stringify(apiMessage) : apiMessage);
        this.$toast.error(`Erreur chargement comptables: ${toastMsg}`);
      } finally {
        this.isLoading = false;
      }
    },

    fetchSuggestions() {
      // Debounce : Attendre 300ms avant de filtrer les suggestions
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        // Filtrer les comptables selon la recherche
        if (this.search.length > 0) {
          // Filtrer selon la recherche
          this.filteredSuggestions = this.allComptables.filter(suggestion =>
              suggestion.fullName.toLowerCase().includes(this.search.toLowerCase()) ||
              (suggestion.email && suggestion.email.toLowerCase().includes(this.search.toLowerCase()))
          );
        } else {
          // Si pas de recherche, afficher tous les comptables
          this.filteredSuggestions = this.allComptables;
        }
        this.showOptions = this.filteredSuggestions.length > 0;
      }, 300);
    },

    // Sélection d'un comptable dans la liste
    selectSuggestion(comptable) {
      this.selectedAccountant = comptable;
      this.search = comptable.fullName;
      this.showOptions = false;
    },

    // Fermeture des options avec délai
    closeOptions() {
      setTimeout(() => {
        this.showOptions = false;
      }, 200);
    },

    // Ouvrir la liste des comptables
    openOptions() {
      if (this.allComptables.length > 0) {
        this.showOptions = true;
        if (this.search.length === 0) {
          this.filteredSuggestions = this.allComptables;
        }
      }
    },

    // Réinitialiser la sélection
    clearSelection() {
      this.search = '';
      this.selectedAccountant = null;
      this.filteredSuggestions = this.allComptables;
      this.showOptions = false;
    },

    // Marquer la demande comme traitée ou rejetée
    async markAsTreated(state) {
      this.charge = true;
      const data = {
        apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
        id: this.oneDetail.request.id,
        state: state,
      };

      try {
        await updateRequestExpert(data);
        
        if (state === 'TREATED') {
          await this.createAffectation();
          this.$toast.success('La demande a été traitée avec succès');
        } else {
          this.$toast.success('La demande a été rejetée');
        }

        this.$emit('closeDetail', true);
      } catch (error) {
        console.error('Erreur:', error);
        this.$toast.error('Une erreur est survenue');
      } finally {
        this.charge = false;
      }
    },

    // Créer l'affectation
    async createAffectation() {
      if (!this.selectedAccountant) {
        this.$toast.error('Veuillez sélectionner un comptable');
        return;
      }

      try {
        const data = {
          apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
          companyId: [this.oneDetail.company.id],
          userId: this.selectedAccountant.id,
        };

        const response = await createAffectation(data);
        console.log('Affectation créée:', response);
        this.$toast.success('Affectation réussie');
      } catch (error) {
        console.error('Erreur affectation:', error);
        this.$toast.error("Erreur lors de l'affectation");
        throw error;
      }
    }
  },
}
</script>

<template>
  <div class="popup-overlay">
    <div class="popup-content bg-white w-1/3 py-5 relative">
      <!-- Header -->
      <div class="flex font-c5 text-c22 colorBorderB pb-5 px-5 justify-between">
        <!-- Titre de la demande et nom de l'entreprise -->
        <div class="font-c7 text-c22">Gestion de la demande <span class="font-c8">( {{ oneDetail.company.fullName }} )</span></div>
        <div
          class="cursor-pointer hover:text-red-500"
          @click="closeDetail"
        >
          ✕
        </div>
      </div>

      <div class="mt-5">
        <div class="mx-5">
          <!-- Label -->
          <div class="text-left mb-3 text-c16 font-c6">
            Sélectionner un expert comptable
            <span
              v-if="allComptables.length > 0"
              class="text-gray-500 text-sm ml-2"
            >
              ({{ allComptables.length }} disponible{{ allComptables.length > 1 ? 's' : '' }})
            </span>
          </div>

          <!-- Input autocomplete -->
          <div class="relative">
            <input
              id="c1a"
              ref="c1a"
              v-model="search"
              type="text"
              class="h-14 bgInpout w-full rounded-10 pl-5 pr-10"
              placeholder="Rechercher un expert comptable..."
              :disabled="isLoading"
              @input="fetchSuggestions"
              @focus="openOptions"
              @blur="closeOptions"
            >
            
            <!-- Bouton pour effacer -->
            <button
              v-if="search"
              class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              @click="clearSelection"
            >
              ✕
            </button>
          </div>

          <!-- Liste des suggestions -->
          <div
            v-if="showOptions && filteredSuggestions.length"
            class="options absolute z-50 bg-white rounded-10 shadow-lg mt-2 max-h-80 overflow-y-auto"
            style="width: calc(100% - 2.5rem);"
          >
            <div
              v-for="(suggestion, index) in filteredSuggestions"
              :key="suggestion.id || index"
              class="one-option flex items-center cursor-pointer p-3 hover:bg-gray-100 border-b border-gray-100 last:border-b-0"
              @mousedown.prevent="selectSuggestion(suggestion)"
            >
              <!-- <img
                :src="icons.entreprise"
                alt="icon"
                class="w-8 h-8 mr-3"
              > -->
              <div class="flex-1">
                <div class="text-black text-sm font-medium">
                  {{ suggestion.fullName }}
                </div>
                <div class="text-gray-500 text-xs">
                  {{ suggestion.email }}
                </div>
                <div
                  v-if="suggestion.phone || suggestion.phoneNumber"
                  class="text-gray-400 text-xs mt-1"
                >
                  {{ suggestion.phone || suggestion.phoneNumber }}
                </div>
              </div>
            </div>
          </div>

          <!-- Message si aucun résultat -->
          <div
            v-if="search.length > 0 && !isLoading && filteredSuggestions.length === 0 && !showOptions"
            class="mt-2 text-gray-500 text-sm p-2"
          >
            Aucun expert comptable trouvé pour "{{ search }}"
          </div>

          <!-- Message pour afficher tous les comptables disponibles -->
          <div
            v-if="!search && !isLoading && allComptables.length > 0 && !showOptions"
            class="mt-2 text-gray-500 text-sm p-3 cursor-pointer hover:text-gray-700 border border-gray-200 rounded-8 bg-gray-50"
            @click="openOptions"
          >
            📋 Veuillez choisir un expert comptable.
          </div>

          <!-- Loading -->
          <div
            v-if="isLoading"
            class="mt-2 text-gray-500 text-sm p-2"
          >
            Chargement des comptables...
          </div>

          <!-- Aperçu du comptable sélectionné -->
          <div
            v-if="selectedAccountant"
            class="flex items-start gap-4 w-full mt-6 border rounded-14 border-gray-300 p-5 bg-gray-50"
          >
            <!-- <img
              :src="icons.ic_enterprise"
              alt="icon"
              class="w-10 h-10"
            > -->
            <div class="flex-1">
              <div class="text-left text-lg font-semibold text-gray-800">
                {{ selectedAccountant.fullName }}
              </div>
              <div class="text-left text-gray-600 text-sm mt-1">
                {{ selectedAccountant.email }}
              </div>
              <div
                v-if="selectedAccountant.phone"
                class="text-left text-gray-500 text-xs mt-1"
              >
                {{ selectedAccountant.phone }}
              </div>
            </div>
          </div>
        </div>

        <!-- Boutons d'action -->
        <div class="flex justify-end items-center mt-6 mx-5 gap-3">
          <button
            class="font-c5 text-white bg-red px-7 py-3 rounded-8 cursor-pointer hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="charge"
            @click="markAsTreated('REJECTED')"
          >
            {{ charge ? 'Traitement...' : 'Rejeter' }}
          </button>
          <button
            class="save text-white px-10 py-3 rounded-8 cursor-pointer hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="charge || !selectedAccountant"
            @click="markAsTreated('TREATED')"
          >
            {{ charge ? 'Traitement...' : 'Marquer comme traité' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.textTitle{
  color: #303030;
}
.bgTitle{
  background-color: #F7DCBC70;
}

.bgDesc{
  background-color: #FAFBFD;
}
.save{
  background-color: #241A72;
}
.colorBorderB{
  border-bottom: 3px solid #E7EEF8;
}
.bgInpout{
  border: 1px solid #E0E0E0;
  background-color: #FAFAFA;
}
.bgInpout:focus{
  outline: none;
  border-color: #241A72;
}
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.popup-content {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  overflow: visible;
  min-height: 5rem;
  max-height: 90vh;
}
.relative {
  position: relative;
}
.options {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 1px solid #E0E0E0;
}
</style>